export const CLOUDFLARE_IMAGES_HOST = 'imagedelivery.net';

export type RoomPhotoLike = {
  imageUrl?: string | null;
  isHero?: boolean | null;
};

const isCloudflareImagesHost = (hostname: string): boolean =>
  hostname === CLOUDFLARE_IMAGES_HOST ||
  hostname.endsWith(`.${CLOUDFLARE_IMAGES_HOST}`);

/**
 * Swap the Cloudflare Images named variant (the last path segment) without
 * accidentally replacing "public" inside unrelated URLs.
 */
export const withCloudflareVariant = (
  imageUrl: string,
  variant: string,
): string => {
  const trimmed = imageUrl.trim();
  if (!trimmed || !variant) {
    return trimmed;
  }

  try {
    const url = new URL(trimmed);
    if (!isCloudflareImagesHost(url.hostname)) {
      return trimmed;
    }

    const segments = url.pathname.split('/').filter(Boolean);
    if (segments.length >= 3) {
      segments[segments.length - 1] = variant;
      url.pathname = `/${segments.join('/')}`;
      return url.toString();
    }
  } catch {
    // Fall through to the trailing-segment replace for non-URL strings.
  }

  return trimmed.replace(/\/public\/?$/, `/${variant}`);
};

export const getRoomOriginalImageUrl = (
  photos?: RoomPhotoLike[] | null,
): string => {
  if (!photos?.length) {
    return '';
  }

  const hero = photos.find(photo => photo.isHero) ?? photos[0];
  return hero.imageUrl?.trim() ?? '';
};

export const getRoomHeroImageUrl = (
  photos?: RoomPhotoLike[] | null,
  variant = 'ROOMGRID',
): string => {
  const originalUrl = getRoomOriginalImageUrl(photos);
  if (!originalUrl) {
    return '';
  }

  return withCloudflareVariant(originalUrl, variant);
};
